'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import ChevronLeftIcon from '@/fo/icons/base/icons/chevron24.svg';

import { Navigation } from '../types';

import { styles } from './UiArticleNavigationBase.styles';

export interface UiArticleNavigationBaseProps {
  navigation: Navigation;
  onActiveClick?: () => void;
}

export function UiArticleNavigationBase({
  navigation,
  onActiveClick
}: UiArticleNavigationBaseProps) {
  const slots = styles();

  const pathname = usePathname();

  const handleClick = (href: string) => {
    if (href === pathname) {
      onActiveClick?.();
    }
  };

  return (
    <nav className={slots.base()}>
      {navigation.menu.map((item) => (
        <Link
          className={slots.link({ active: item.href === pathname })}
          href={item.href}
          onClick={() => handleClick(item.href)}
          key={item.href}
        >
          {item.label}
          <ChevronLeftIcon className={slots.icon()} />
        </Link>
      ))}
    </nav>
  );
}
